/**
 * @generated SignedSource<<a0279010fb304d1af2853678f8ddf678>>
 * @relayHash 91d8534d58f066b9d33fdcb5f9550446
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 91d8534d58f066b9d33fdcb5f9550446

import { ConcreteRequest } from 'relay-runtime';
export type useLazyLoadedToolsQuery$variables = {
  limitFetchedPopularTools: number;
  skipFetchPopularTools: boolean;
};
export type useLazyLoadedToolsQuery$data = {
  readonly popularToolsForUser?: ReadonlyArray<{
    readonly __typename: "Tool";
    readonly id: string;
    readonly logoImage: {
      readonly uid: string;
    } | null;
    readonly name: string;
  }>;
  readonly suggestedTools: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "Tool";
        readonly id: string;
        readonly logoImage: {
          readonly uid: string;
        } | null;
        readonly name: string;
      };
    }>;
  };
};
export type useLazyLoadedToolsQuery = {
  response: useLazyLoadedToolsQuery$data;
  variables: useLazyLoadedToolsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limitFetchedPopularTools"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipFetchPopularTools"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "logoImage",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limitFetchedPopularTools"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "logoImage",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLazyLoadedToolsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SuggestedToolConnection",
        "kind": "LinkedField",
        "name": "suggestedTools",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SuggestedToolEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Tool",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "skipFetchPopularTools",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "Tool",
            "kind": "LinkedField",
            "name": "popularToolsForUser",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useLazyLoadedToolsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SuggestedToolConnection",
        "kind": "LinkedField",
        "name": "suggestedTools",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SuggestedToolEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Tool",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "skipFetchPopularTools",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "Tool",
            "kind": "LinkedField",
            "name": "popularToolsForUser",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "91d8534d58f066b9d33fdcb5f9550446",
    "metadata": {},
    "name": "useLazyLoadedToolsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "92678f2059d85be785d7c9e8f9e2b7c9";

export default node;
